import React, { useState, useCallback, useEffect, useRef } from "react";
import { Grid } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import { useQuery } from "redux/action/api";
import { postApi } from "redux/action/api_tbeams";
import { resolveFileUrl, fileNameFromUrl } from "redux/action/fileUpload";
import {
  Card,
  Spinner,
  Table,
  Col,
  Row,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Label,
  Input,
  Button,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledButtonDropdown,
} from "reactstrap";
import { formatNumber } from "redux/action/api";
import RealiseCollectionPdfWebView from "components/RealiseCollectionPdfWebView";
import NewRelisePdfWebView from "components/NewRelisePdfWebView";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
// import moment from "moment";
import moment from "moment";
import { logout } from "redux/action/auth";
import { IoMdCheckmark } from "react-icons/io";
import { MdOutlineCancel } from "react-icons/md";
import { useToasts } from "helper/ToastAdapter";
import { fetchApi } from "redux/action/api_tbeams";
import { _fetchApi } from "redux/action/api";
import { _postApi } from "redux/action/api";
import RemarksList from "./Remarks";
import { getSector } from "helper";
import { getMDaType } from "helper";
import { Typeahead } from "react-bootstrap-typeahead";
import { getDistinctObjects } from "./CapitalProject";

export default function ViewRelease() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const query = useQuery();
  const { addToast } = useToasts();
  const user = useSelector((e) => e.auth.user);
  const approval_status = query.get("approval_status");
  const return_status = query.get("return_status");
  const showButton = query.get("showButton");
  const approval_no = query.get("approval_no");
  const title = query.get("title");
  const types = query.get("type");
  const approved_ids = query.get("approved_ids");
  const id = query.get("id");

  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [submittingReview, setSubmittingReview] = useState(false);
  const [display, setDisplay] = useState(types !== "Budget Approval Released");
  const [form, setForm] = useState({ remark: "", rejact: "" });
  const [modal, setModal] = useState(false);
  const [modal1, setModal1] = useState(false);
  const [discard, setDiscard] = useState(false);
  const [loading, setLoading] = useState(false);
  const [budget_amount, setAmount] = useState("");
  const [remarks, setRemarks] = useState([]);
  const [edit, setEdit] = useState(false);
  const toggle = () => setModal((prevState) => !prevState);
  const toggle1 = () => setModal1(!modal1);

  const [users, setUsers] = useState({});
  const [directors, setDirectors] = useState([]);
  const [createdBy, setCreatedBy] = useState(""); // For storing the username
  const [attachments, setAttachments] = useState([]);
  const [showAttachments, setShowAttachments] = useState(false);
  const [viewingAttachment, setViewingAttachment] = useState(null);
  const [attachmentModal, setAttachmentModal] = useState(false);
  const discardToggle = () => setDiscard(!discard);
  const toggleEdit = () => setEdit(!edit);
  const toggleAttachmentModal = () => setAttachmentModal(!attachmentModal);
 const _data = data.length ? data[0] : {};
  // Handle API errors and check for authentication
  const handleApiError = (error) => {
    console.error("API Error:", error);

    // Check if error is related to authentication (401 or token expired)
    if (
      error?.status === 401 ||
      error?.message?.includes("token") ||
      error?.message?.includes("unauthorized")
    ) {
      addToast("Session expired. Please login again.", {
        appearance: "error",
        autoDismiss: true,
        autoDismissTimeout: 3000,
      });

      // Logout user after a short delay
      setTimeout(() => {
        dispatch(logout());
      }, 1000);

      return true; // Indicates auth error
    }

    return false; // Not an auth error
  };

  const handleChanges = ({ target: { name, value } }) =>
    setForm((p) => ({ ...p, [name]: value }));

  const getRowStyle = (row) => {
    switch (row.approval_status) {
      case "Approval Released":
        return { backgroundColor: "orange" };
      case "Approval Processed":
        return { backgroundColor: "lightblue" };
      case "Approval Approved":
        return { backgroundColor: "lightgreen" };
      case "Approval Queried":
        return { backgroundColor: "yellow" };
      case "Payment Schedule":
        return { backgroundColor: "blue" };
      case "No Budget":
        return { backgroundColor: "#cc8888" };
      case "paid":
        return { backgroundColor: "green" };
      default:
        return { backgroundColor: "" };
    }
  };

  useEffect(() => {
    getMDaType({},  approved_ids,  setDirectors, "select_director");
  }, [approved_ids]);

  const getApprovalCollection = useCallback(() => {
    setIsLoading(true);
    postApi(`post_approval_collection`, {
      form: {
        query_type: "select_by_approval_nos",
        approval_no,
      },
    })
      .then((data) => {
        // Check for authentication errors
        if (!data || data.error === "Unauthorized" || data.status === 401) {
          handleApiError({ status: 401, message: "Unauthorized" });
          return;
        }

        setData(data.result);
        const _data = data.result.length ? data.result[0] : {};
        // alert(JSON.stringify(_data));

        // Fetch attachments
        if (_data.approval_no) {
          console.log(
            "Fetching attachments for approval_no:",
            _data.approval_no,
          );
          postApi(`fetch_approval_images`, {
            approval_no: _data.approval_no,
          })
            .then((response) => {
              console.log("Attachments response:", response);
              if (response.success && response.result) {
                // Handle both array formats
                const attachmentData = Array.isArray(response.result[0])
                  ? response.result[0]
                  : response.result;
                console.log("Processed attachments:", attachmentData);
                setAttachments(attachmentData || []);
              } else {
                console.log("No attachments found");
                setAttachments([]);
              }
            })
            .catch((err) => {
              console.log("Error fetching attachments:", err);
              setAttachments([]);
            });
        }

        // Fetch fullname if user_id exists
        if (_data.user_id) {
          fetchApi(`sign-by-id-new?id=${_data.user_id}`)
            .then((userData) => {
              console.log(userData, "KKDKDKDK");
              setCreatedBy(userData?.data[0]?.name || "Unknown");
            })
            .catch((err) => {
              console.log("Error fetching user:", err);
              setCreatedBy("Unknown");
            });
        }

        getMDaType(
          {},
          _data.mda_code,
          (d) => {
            setForm((p) => ({ ...p, mda_sn: d[0]?.mda_sn || "" }));
          },
          "select_sn",
        );
        _fetchApi(
          `/sign-by-id-new?id=${_data.approved_ids}`,
          (d) => {
            if (d.success) {
              setUsers(d?.data[0]);
            }
          },
          (err) => {
            console.log(err);
          },
        );
        postApi(`update_budget_balance`, {
          query_type: "select",
          mda_name: _data.mda_name,
          mda_code: _data.mda_code,
          amount: null,
          economic_code: _data?.economic_code,
          program_code: _data?.program_code,
        })
          .then((d) => {
            // console.log("data", d);
            if (d.success) {
              const selectedItem = d.data[0];
              setAmount(selectedItem);
            }
          })
          .catch((err) => {
            // Handle errors
            console.log(err);
          })
          .finally(() => {
            setIsLoading(false);
          });

        // fetchApi(
        //   `get-budget-summary?query_type=fetch_budget&mda_code=${_data?.mda_code}&economic_code=${_data?.economic_code}`
        // ).then((d) => {
        //   console.log(d);
        //   if (d.result && d.result?.length) {
        //     console.log("Budget", d);
        //     const selectedItem = d.result[0];
        //     setAmount(selectedItem);
        //     console.log(d, "jhgjahg");
        //   }
        // });
      })
      .catch((err) => {
        console.log(err);
        if (!handleApiError(err)) {
          addToast("Error loading release details", {
            appearance: "error",
            autoDismiss: true,
          });
        }
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [id]);

  let styles = {
    fontSize: 15,
    padding: 2,
  };

  const bodyStyle = (item) => {
    return { fontSize: 15, padding: 2, ...getRowStyle(item) };
  };

 
  const pdfData = data.map((i) => ({
    ...i,
    approved_amount: i.amount,
    mda_economic_code: i.economic_code,
    description: i.description_code,
  }));
  const total = data.reduce((acc, item) => acc + parseFloat(item.amount), 0);
  const previewPdf = () => setDisplay(!display);

  useEffect(() => {
    getApprovalCollection();
  }, [getApprovalCollection]);

  // let payable = _data.project_type === "payable-to";
  const updateBalance = () => {
    console.log("Updating balance for items:", data.length);

    // Create promises for each item in the data array
    const promises = data.map((item, index) => {
      console.log(`Sending request ${index + 1}/${data.length}:`, {
        mda_code: item.mda_code,
        economic_code: item.economic_code,
        amount: item.amount,
      });

      return postApi(`update_budget_balance`, {
        query_type: "update_balance",
        mda_name: item.mda_name,
        mda_code: item.mda_code,
        amount: item.amount,
        economic_code: item.economic_code,
        description: item.description_code,
        geo_code: item.geo_code,
        program_code: item.program_code,
        functional_code: item.functional_code,
        approval_no: item.approval_no,
        admin_code: item.mda_code,
        collection_date: item.collection_date,
      })
        .then((result) => {
          console.log(`Response ${index + 1}:`, result);
          return result;
        })
        .catch((err) => {
          console.error(`Error ${index + 1}:`, err);
          return { success: false, error: err };
        });
    });

    console.log(`Created ${promises.length} promises`);

    Promise.all(promises)
      .then((results) => {
        console.log("All results:", results);
        const successCount = results.filter((r) => r.success).length;
        const failCount = results.length - successCount;

        if (failCount === 0) {
          addToast(`All ${successCount} balances updated successfully`, {
            appearance: "success",
            autoDismiss: true,
            autoDismissTimeout: 5000,
          });
        } else if (successCount > 0) {
          addToast(`${successCount} balances updated, ${failCount} failed`, {
            appearance: "warning",
            autoDismiss: true,
            autoDismissTimeout: 5000,
          });
        } else {
          addToast("All balance updates failed", {
            appearance: "error",
            autoDismiss: true,
            autoDismissTimeout: 5000,
          });
        }
      })
      .catch((err) => {
        console.error("Promise.all error:", err);
        addToast("Error updating balances", {
          appearance: "error",
          autoDismiss: true,
          autoDismissTimeout: 5000,
        });
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const getCCCopies = useCallback(() => {
    postApi(`post-cc?query_type=select_mda`, { mda_name: _data.mda_name })
      .then((data) => {
        console.log("data", data);
        if (data.results) {
          setForm((p) => ({
            ...p,
            ..._data,
            mda_sn: _data?.reference,
            approved_amount: _data.amount,
            copies: data.results[0],
            mda_economic_code: _data.economic_code,
          }));
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, [_data.mda_name]);

  const getCCCopies1 = useCallback(() => {
    postApi(`post-cc?query_type=select_mda`, { mda_name: _data.mda_head })
      .then((data) => {
        console.log("data", data);
        if (data.results) {
          setForm((p) => ({
            ...p,
            ..._data,
            approved_amount: _data.amount,
            copies1: data.results[0],
            mda_economic_code: _data.economic_code,
          }));
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, [_data.mda_head]);

  const postRemarks = () => {
    postApi(`auditor_general_remark?query_type=insert`, {
      approval_no: id || approval_no,
      remark: form.remark,
      user_id: user.id,
      created_at: moment().format("YYYY-MM-DD HH:mm:ss"),
    })
      .then(() => {
        _postRemarks();
        if (data.success) {
          addToast("Remarks added successfully", {
            appearance: "info",
            autoDismiss: true,
            autoDismissTimeout: 5000,
          });
        }
      })
      .catch((err) => {
        console.log(err);
        addToast("An error occurred", {
          appearance: "danger",
          autoDismiss: true,
          autoDismissTimeout: 5000,
        });
      });
  };

  const _postRemarks = useCallback(() => {
    postApi(`auditor_general_remark`, {
      approval_no: id,
      remark: form.remark,
      user_id: user.id,
      created_at: moment().format("YYYY-MM-DD HH:mm:ss"),
    })
      .then((data) => {
        setRemarks(data?.results);
        // console.log(data, "=======================DDDDD=======");
      })
      .catch((err) => {
        console.log(err);
      });
  }, [id || approval_no]);

  useEffect(() => {
    getCCCopies();
    getCCCopies1();
  }, [getCCCopies, getCCCopies1]);

  useEffect(() => {
    _postRemarks();
  }, [_postRemarks]);

  const approveRequest = (status) => {
    // Validate remarks for Return action
    if (
      status === return_status &&
      (!form.remark || form.remark.trim() === "")
    ) {
      addToast("Remark is required when returning a release", {
        appearance: "error",
        autoDismiss: true,
        autoDismissTimeout: 5000,
      });
      setLoading(false);
      return;
    }

    // alert(JSON.stringify(data));
    setLoading(true);
    if (form.remark !== "") {
      postRemarks();
    }
    postApi(`update-approval`, {
      mda_name: _data.mda_name,
      approval_no: _data.approval_no,
      id: _data.id,
      status,
      remarks: form.remark,
      userId: status === "Approval Released" ? user.id : _data.approved_ids,
      query_type: "new-update",
    })
      .then((data) => {
        // Check for authentication errors
        if (!data || data.error === "Unauthorized" || data.status === 401) {
          handleApiError({ status: 401, message: "Unauthorized" });
          return;
        }

        if (data.success) {
          if (discard) {
            discardToggle();
          } else {
            setModal(false);
          }
          setLoading(false);
          if (status?.includes("Budget Approval Released")) {
            updateBalance();
            // alert(JSON.stringify(status));
          }
          getApprovalCollection();
          navigate(-1);
          addToast("Approve successfully", {
            appearance: "info",
            autoDismiss: true,
            autoDismissTimeout: 5000,
          });
        }
      })
      .catch((err) => {
        // Handle errors
        console.log(err);
        if (!handleApiError(err)) {
          addToast("An error occurred", {
            appearance: "danger",
            autoDismiss: true,
            autoDismissTimeout: 5000,
          });
        }
        setLoading(false);
      })
      .finally(() => {
        // setIsUpdating(false);
        setLoading(false);
      });
  };

  const onEditClick = (item) => {
    const header = data.length ? data[0] : {};

    // Detect release type from approval_type field
    const approvalType = header.approval_type || item.approval_type || "Recurrent";
    const detectedStep =
      approvalType === "Capital" ? "2" : "1";
    setEditSteps(detectedStep);

    setForm((p) => ({
      ...p,
      approval_no: header.approval_no || item.approval_no,
      collection_date: header.collection_date || item.collection_date,
      approval_date: header.approval_date || item.approval_date,
      approved_by: header.approved_by || item.approved_by,
      narration: header.narration || item.narration,
      add_remark: header.add_remark || "",
      mda_name: header.mda_name || item.mda_name,
      mda_code: header.mda_code || item.mda_code,
      economic_code: header.economic_code || item.economic_code,
      mda_economic_code: header.economic_code || item.economic_code,
      description_code: header.description_code || item.description_code,
      mda_description: header.description_code || item.description_code,
      approved_amount: header.approved_amount || header.amount || item.amount,
      mda_head: header.mda_head || item.mda_head || "",
      mda_head_code: header.send_to_office || item.send_to_office || "",
      send_to_office: header.send_to_office || item.send_to_office || "",
      cc: header.cc || item.cc || "",
      cc_mda_name: header.cc || item.cc || "",
      program_code: header.program_code || item.program_code || "",
      geo_code: header.geo_code || item.geo_code || "",
      functional_code: header.functional_code || item.functional_code || "",
      fund_code: header.fund_code || item.fund_code || "",
      project_type: header.project_type || item.project_type || "",
    }));

    setData((prev) =>
      prev.map((i) =>
        i.mda_code === item.mda_code && i.economic_code === item.economic_code
          ? { ...i, editing: true }
          : i,
      ),
    );

    setEdit(true);
  };

  // Update header-level fields and propagate to all data rows
  const handleHeaderChange = (name, value) => {
    setForm((p) => ({ ...p, [name]: value }));
    setData((prev) => prev.map((it) => ({ ...it, [name]: value })));
  };

  const handleDataChange = (name, value, idx) => {
    setData((prev) =>
      prev.map((item, i) => (i === idx ? { ...item, [name]: value } : item)),
    );
  };

  const submitReview = () => {
    const errors = [];
    data.forEach((item, idx) => {
      if (!item.mda_code) errors.push(`Row ${idx + 1}: MDA Code is required`);
      if (!item.mda_name) errors.push(`Row ${idx + 1}: MDA Name is required`);
      if (!item.narration) errors.push(`Row ${idx + 1}: Narration is required`);
      if (!item.amount) errors.push(`Row ${idx + 1}: Amount is required`);
      if (!item.economic_code && !item.program_code)
        errors.push(
          `Row ${idx + 1}: Either Economic Code or Program Code must be provided`,
        );
    });
    if (errors.length) {
      errors.forEach((msg) =>
        addToast(msg, {
          appearance: "error",
          autoDismiss: true,
          autoDismissTimeout: 5000,
        }),
      );
      setSubmittingReview(false);
      return;
    }

    setSubmittingReview(true);

    // Merge header-level form fields into every row so the backend receives
    // the latest values even if the user didn't touch the per-row section.
    // Header fields are merged with `??` rather than `||` so that a field the
    // user deliberately cleared is sent as cleared instead of silently falling
    // back to the value that was loaded with the release.
    const modified = data.map((a) => ({
      ...a,
      // Header fields (shared across rows)
      approval_no:      form.approval_no      ?? a.approval_no,
      collection_date:  form.collection_date  ?? a.collection_date,
      approval_date:    form.approval_date    ?? a.approval_date,
      approved_by:      form.approved_by      ?? a.approved_by,
      narration:        a.narration           || form.narration,
      cc:               form.cc               ?? a.cc,
      mda_head:         form.mda_head         ?? a.mda_head,
      send_to_office:   form.send_to_office   ?? a.send_to_office,
      project_type:     form.project_type     ?? a.project_type,
      // Amount: prefer the value edited in the form, fall back to row value
      approved_amount:  form.approved_amount  || a.amount,
      amount:           form.approved_amount  || a.amount,
      // Codes: prefer Typeahead-selected values in form
      mda_name:         form.mda_name         ?? a.mda_name,
      mda_code:         form.mda_code         ?? a.mda_code,
      economic_code:    form.mda_economic_code ?? form.economic_code ?? a.economic_code,
      mda_economic_code: form.mda_economic_code ?? form.economic_code ?? a.economic_code,
      description_code: form.description_code ?? form.mda_description ?? a.description_code,
      program_code:     form.program_code     ?? a.program_code,
    }));

    postApi(`update_releases`, {
      approval_no: form.approval_no,
      query_type: "update_release",
      data: modified,
      userId: user.id,
    })
      .then((resp) => {
        if (!resp || resp.error === "Unauthorized" || resp.status === 401) {
          handleApiError({ status: 401, message: "Unauthorized" });
          return;
        }

        if (resp.success) {
          setEdit(false);
          getApprovalCollection();
          navigate(-1);
          addToast("Updated successfully", {
            appearance: "success",
            autoDismiss: true,
            autoDismissTimeout: 5000,
          });
        } else {
          addToast(resp.error || "Update failed. Please try again.", {
            appearance: "error",
            autoDismiss: true,
            autoDismissTimeout: 5000,
          });
        }
      })
      .catch((err) => {
        console.log(err);
        if (!handleApiError(err)) {
          addToast("An error occurred while updating", {
            appearance: "error",
            autoDismiss: true,
            autoDismissTimeout: 5000,
          });
        }
      })
      .finally(() => {
        setSubmittingReview(false);
      });
  };

  const [openRemark, setOpenRemark] = useState(false);
  const handleRemark = () => {
    setOpenRemark(!openRemark);
  };

  // ── Edit form: Typeahead data & refs ──────────────────────────────────────
  const [editSteps, setEditSteps] = useState("1");
  const [economicCode, setEconomicCode] = useState([]);
  const [filteredEconomicCode, setFilteredEconomicCode] = useState([]);
  const [distinctAdmins, setDistinctAdmins] = useState([]);
  const [allMdaAdmins, setAllMdaAdmins] = useState([]);
  const [fetching, setFetching] = useState(false);
  const [balLoanding, setBalLoanding] = useState(false);

  const mdaRef = useRef();
  const economicRef = useRef();
  const ccMdaRef = useRef();
  const fundRef = useRef();
  const functionalRef = useRef();
  const programRef = useRef();
  const geoRef = useRef();

  // Load budget summary for Typeahead options when edit modal opens
  const loadEditBudgetData = useCallback(() => {
    setFetching(true);
    const loadType = (type) =>
      fetchApi(`get-budget-summary?query_type=${type}`)
        .then((d) => (d.result ? d.result : []))
        .catch(() => []);

    Promise.all([loadType("recurrent"), loadType("capital")]).then(
      ([recurrentData, capitalData]) => {
        const merged = [...recurrentData, ...capitalData];
        setEconomicCode(merged);
        const allAdmins = getDistinctObjects(merged, "admin_code", "admin_description");
        setAllMdaAdmins(allAdmins);
        setDistinctAdmins(
          getDistinctObjects(
            editSteps === "2" ? capitalData : recurrentData,
            "admin_code",
            "admin_description",
          ),
        );
        setFetching(false);
      },
    );
  }, [editSteps]);

  useEffect(() => {
    if (edit) loadEditBudgetData();
  }, [edit]);

  // Filter economic codes when MDA or economicCode list changes
  useEffect(() => {
    if (form.mda_code && economicCode.length) {
      const filtered = economicCode.filter(
        (item) =>
          item.admin_code === form.mda_code ||
          item.mda_code === form.mda_code,
      );
      setFilteredEconomicCode(filtered);
    }
  }, [form.mda_code, economicCode]);

  // Fetch budget balance for edit form
  const getBudgetBalanceForEdit = useCallback(() => {
    if (!form.mda_code) return;
    setBalLoanding(true);
    postApi(`update_budget_balance`, {
      query_type: "select",
      mda_name: form.mda_name,
      mda_code: form.mda_code,
      amount: null,
      economic_code: form.mda_economic_code || form.economic_code,
      program_code: form.program_code,
      functional_code: form.functional_code,
      geo_code: form.geo_code,
    })
      .then((d) => {
        if (d.success && d.data?.[0]) {
          const selectedItem = d.data[0];
          setForm((p) => ({
            ...p,
            mda_budget_balance:
              selectedItem.balance === 0 || selectedItem.balance === "0" ? "Budget Exhausted" : selectedItem.balance,
            budget: selectedItem.approve_amount === 0 || selectedItem.approve_amount === "0" ? "Budget Exhausted" : selectedItem.approve_amount,
          }));
        }
      })
      .catch(() => {})
      .finally(() => setBalLoanding(false));
  }, [form.mda_code, form.mda_economic_code, form.economic_code, form.program_code]);

  useEffect(() => {
    if (edit) getBudgetBalanceForEdit();
  }, [form.mda_code, form.mda_economic_code, form.economic_code, edit]);

  // Typeahead handlers for edit form
  const handleEditMdaCode = (selected) => {
    if (selected?.length) {
      const s = selected[0];
      getMDaType({}, s.admin_code, (d) => {
        setForm((p) => ({ ...p, mda_sn: d[0]?.mda_sn || "" }));
      }, "select_sn");
      const filtered = economicCode.filter(
        (item) => item.admin_code === s.admin_code || item.mda_code === s.admin_code,
      );
      setFilteredEconomicCode(filtered);
      setForm((p) => ({
        ...p,
        mda_code: s.admin_code,
        mda_name: s.admin_description,
        mda_budget_balance: "",
        budget: "",
      }));
      setData((prev) => prev.map((it) => ({ ...it, mda_code: s.admin_code, mda_name: s.admin_description })));
    } else {
      setForm((p) => ({ ...p, mda_code: "", mda_name: "", mda_budget_balance: "", budget: "" }));
    }
  };

  const handleEditMdaCode1 = (selected) => {
    if (selected?.length) {
      const s = selected[0];
      setForm((p) => ({
        ...p,
        mda_head_code: s.admin_code,
        mda_head: s.admin_description,
        send_to_office: s.admin_code,
        project_type: "payable-to",
      }));
      // Resolve the CC office for the newly selected head so the form shows the
      // right copy instead of the one loaded with the release.
      postApi(`post-cc?query_type=select_mda`, { mda_name: s.admin_description })
        .then((data) => {
          setForm((p) =>
            data.results && p.mda_head_code === s.admin_code
              ? { ...p, copies1: data.results[0] }
              : p,
          );
        })
        .catch((err) => console.log(err));
    } else {
      // Clearing the payable-to MDA must also drop the payable flag and the CC
      // copy, otherwise the release keeps rendering as payable to the old head.
      setForm((p) => ({
        ...p,
        mda_head_code: "",
        mda_head: "",
        send_to_office: "",
        project_type: "",
        copies1: {},
      }));
    }
  };

  const handleEditEconomicCode = (selected) => {
    if (selected?.length) {
      const s = selected[0];
      setForm((p) => ({
        ...p,
        economic_code: s.economic_code,
        mda_economic_code: s.economic_code,
        description_code: s.economic_description,
        mda_description: s.economic_description,
      }));
      setData((prev) =>
        prev.map((it) => ({ ...it, economic_code: s.economic_code, description_code: s.economic_description })),
      );
    } else {
      setForm((p) => ({ ...p, economic_code: "", mda_economic_code: "", description_code: "", mda_description: "" }));
    }
  };

  const newUser = title === "Signed Approvals" ? directors[0] : {};

  const handleDeleteApi = (item) => {
    let form = { ...item, query_type: "delete_release" };
    console.log(item);
    if (window.confirm("Are you sure you want to delete this item?")) {
      postApi(`post_approval_collection`, { form })
        .then(() => getApprovalCollection())
        .catch(console.log("Error occur"));
      console.log("Delete confirmed");
      getApprovalCollection();
    } else {
      console.log("Deleting cancel");
    }
  };

  return (
    <div>
      <DashboardLayout>
        <MDBox pt={2} pb={3} px={3}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              {isLoading && (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    padding: "40px",
                  }}
                >
                  <Spinner color="success" />
                  <span style={{ marginLeft: "10px" }}>
                    Loading release details...
                  </span>
                </div>
              )}
{/* {JSON.stringify(_data)} */}
              {!isLoading && (
                <>
                  {/* Header Section */}
                  <MDBox
                    mx={2}
                    mt={-3}
                    py={3}
                    px={3}
                    variant="gradient"
                    bgColor="success"
                    borderRadius="lg"
                    coloredShadow="success"
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      flexWrap: "wrap",
                    }}
                  >
                    <MDTypography
                      variant="h5"
                      color="white"
                      style={{ fontWeight: 600 }}
                    >
                      Release No: {_data.approval_no}
                    </MDTypography>
                    <MDTypography
                      variant="body2"
                      color="white"
                      style={{ opacity: 0.9 }}
                    >
                      Status: {_data.approval_status}
                    </MDTypography>
                  </MDBox>

                  {/* Action Bar */}
                  <Row className="mt-4 mb-3 px-3">
                    <Col md={6} className="d-flex align-items-center">
                      <Button
                        color="warning"
                        size="md"
                        onClick={() => navigate(-1)}
                        style={{
                          fontWeight: 500,
                          boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                        }}
                      >
                        ← Back
                      </Button>
                    </Col>
                    <Col
                      md={6}
                      className="d-flex justify-content-end align-items-center"
                    >
                      <div
                        style={{
                          backgroundColor: "#f8f9fa",
                          padding: "12px 20px",
                          borderRadius: "8px",
                          border: "2px solid #e9ecef",
                          fontWeight: 600,
                        }}
                      >
                        Budget Balance:{" "}
                        <span style={{ color: "#28a745" }}>
                          ₦{formatNumber(budget_amount.mopb_balance)}
                        </span>
                      </div>
                    </Col>
                  </Row>

                  {/* Summary Information Card */}
                  {(types !== "Budget Approval Released" || display) && (
                    <div className="px-3 mb-4">
                      <Card
                        style={{
                          border: "1px solid #e9ecef",
                          borderRadius: "8px",
                          // overflow: "hidden",
                        }}
                      >
                        <div
                          style={{
                            backgroundColor: "#f8f9fa",
                            padding: "15px 20px",
                            borderBottom: "2px solid #dee2e6",
                            fontWeight: 600,
                            fontSize: "16px",
                          }}
                        >
                          Release Summary
                        </div>
                        <Table
                          responsive
                          hover
                          className="mb-0"
                          style={{ paddingBottom: 40 }}
                        >
                          <thead style={{ backgroundColor: "#f1f3f5" }}>
                            <tr>
                              <th style={{ padding: "15px", fontWeight: 600 }}>
                                Collection Date
                              </th>
                              <th style={{ padding: "15px", fontWeight: 600 }}>
                                Approval Date
                              </th>
                              <th style={{ padding: "15px", fontWeight: 600 }}>
                                Approved By
                              </th>
                              <th style={{ padding: "15px", fontWeight: 600 }}>
                                Created By
                              </th>
                              <th style={{ padding: "15px", fontWeight: 600 }}>
                                Total Amount
                              </th>
                              {title !== "Signed Approvals" && (
                                <th
                                  style={{
                                    padding: "15px",
                                    fontWeight: 600,
                                    textAlign: "center",
                                  }}
                                >
                                  Actions
                                </th>
                              )}
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td
                                style={{
                                  padding: "15px",
                                  verticalAlign: "middle",
                                }}
                              >
                                {moment(_data?.collection_date).format(
                                  "MMM DD, YYYY",
                                )}
                              </td>
                              <td
                                style={{
                                  padding: "15px",
                                  verticalAlign: "middle",
                                }}
                              >
                                {moment(_data?.approval_date).format(
                                  "MMM DD, YYYY",
                                )}
                              </td>
                              <td
                                style={{
                                  padding: "15px",
                                  verticalAlign: "middle",
                                }}
                              >
                                <span
                                  style={{
                                    backgroundColor: "#e7f5ff",
                                    padding: "4px 12px",
                                    borderRadius: "4px",
                                    color: "#1971c2",
                                    fontWeight: 500,
                                  }}
                                >
                                  {_data?.approved_by}
                                </span>
                              </td>
                              <td
                                style={{
                                  padding: "15px",
                                  verticalAlign: "middle",
                                }}
                              >
                                {createdBy || (
                                  <Spinner size="sm" color="success" />
                                )}
                              </td>
                              <td
                                style={{
                                  padding: "15px",
                                  verticalAlign: "middle",
                                }}
                              >
                                <span
                                  style={{
                                    fontSize: "16px",
                                    fontWeight: 700,
                                    color: "#28a745",
                                  }}
                                >
                                  ₦{formatNumber(total)}
                                </span>
                              </td>
                              <td
                                style={{
                                  padding: "15px",
                                  verticalAlign: "middle",
                                }}
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    gap: "10px",
                                    justifyContent: "center",
                                    flexWrap: "wrap",
                                  }}
                                >
                                  {types === "Initiated Returned" && (
                                    <UncontrolledButtonDropdown
                                      direction="right"
                                      style={{ zIndex: 500 }}
                                    >
                                      <DropdownToggle
                                        color="success"
                                        caret
                                        size="sm"
                                        style={{ fontWeight: 500 }}
                                      >
                                        Actions
                                      </DropdownToggle>
                                      <DropdownMenu>
                                        <DropdownItem
                                          onClick={() => {
                                            toggle1();
                                            setData(data);
                                          }}
                                        >
                                          <IoMdCheckmark
                                            size="18px"
                                            style={{ marginRight: 6 }}
                                          />
                                          Approve
                                        </DropdownItem>

                                        <DropdownItem
                                          onClick={() => {
                                            toggle();
                                            setData([_data]);
                                          }}
                                        >
                                          <MdOutlineCancel
                                            size="18px"
                                            style={{ marginRight: 6 }}
                                          />
                                          Return
                                        </DropdownItem>

                                        <DropdownItem
                                          onClick={() => {
                                            setDiscard(true);
                                            setData([_data]);
                                          }}
                                        >
                                          <MdOutlineCancel
                                            size="18px"
                                            style={{ marginRight: 6 }}
                                          />
                                          Discard / Delete
                                        </DropdownItem>
                                      </DropdownMenu>
                                    </UncontrolledButtonDropdown>
                                  )}
                                  {/* Action buttons */}
                                  {types !== "Budget Approval Released" &&
                                    title !== "Signed Approvals" &&
                                    (showButton === true ||
                                    showButton === "true" ? null : (
                                      <UncontrolledButtonDropdown
                                        direction="right"
                                        style={{ zIndex: 500 }}
                                      >
                                        <DropdownToggle
                                          color="success"
                                          caret
                                          size="sm"
                                          style={{ fontWeight: 500 }}
                                        >
                                          Actions
                                        </DropdownToggle>
                                        <DropdownMenu>
                                          <DropdownItem
                                            onClick={() => {
                                              toggle1();
                                              setData(data);
                                            }}
                                          >
                                            <IoMdCheckmark
                                              size="18px"
                                              style={{ marginRight: 6 }}
                                            />
                                            Approve
                                          </DropdownItem>

                                          <DropdownItem
                                            onClick={() => {
                                              toggle();
                                              setData([_data]);
                                            }}
                                          >
                                            <MdOutlineCancel
                                              size="18px"
                                              style={{ marginRight: 6 }}
                                            />
                                            Return
                                          </DropdownItem>

                                          <DropdownItem
                                            onClick={() => {
                                              setDiscard(true);
                                              setData([_data]);
                                            }}
                                          >
                                            <MdOutlineCancel
                                              size="18px"
                                              style={{ marginRight: 6 }}
                                            />
                                            Discard / Delete
                                          </DropdownItem>
                                        </DropdownMenu>
                                      </UncontrolledButtonDropdown>
                                    ))}

                                  {/* {types !== "Budget Approval Released" &&
                                    title !== "Signed Approvals" &&
                                    types?.includes("Returned") && (
                                      <UncontrolledButtonDropdown
                                        direction="right"
                                        style={{ zIndex: 300 }}
                                      >
                                        <DropdownToggle
                                          color="success"
                                          caret
                                          size="sm"
                                          style={{ fontWeight: 500 }}
                                        >
                                          Actions
                                        </DropdownToggle>
                                        <DropdownMenu>
                                          <DropdownItem
                                            onClick={() => {
                                              toggle1();
                                              setData([_data]);
                                            }}
                                          >
                                            <IoMdCheckmark
                                              size="18px"
                                              style={{ marginRight: 6 }}
                                            />
                                            Approve
                                          </DropdownItem>

                                          <DropdownItem
                                            onClick={() => {
                                              toggle();
                                              setData([_data]);
                                            }}
                                          >
                                            <MdOutlineCancel
                                              size="18px"
                                              style={{ marginRight: 6 }}
                                            />
                                            Return
                                          </DropdownItem>

                                          <DropdownItem
                                            onClick={() => {
                                              setDiscard(true);
                                              setData([_data]);
                                            }}
                                          >
                                            <MdOutlineCancel
                                              size="18px"
                                              style={{ marginRight: 6 }}
                                            />
                                            Discard / Delete
                                          </DropdownItem>
                                        </DropdownMenu>
                                      </UncontrolledButtonDropdown>
                                    )} */}

                                  {types !== "Budget Approval Released" && (
                                    <Button
                                      color="link"
                                      size="sm"
                                      onClick={handleRemark}
                                      style={{
                                        color: "#ffc107",
                                        fontWeight: 500,
                                        textDecoration: "none",
                                      }}
                                    >
                                      View Remarks
                                    </Button>
                                  )}

                                  <Button
                                    color="link"
                                    size="sm"
                                    onClick={previewPdf}
                                    style={{
                                      color: display ? "#007bff" : "#dc3545",
                                      fontWeight: 500,
                                      textDecoration: "none",
                                    }}
                                  >
                                    {display
                                      ? "Preview Document"
                                      : "Close Document"}
                                  </Button>

                                  {attachments && attachments.length > 0 && (
                                    <Button
                                      color="link"
                                      size="sm"
                                      onClick={() =>
                                        setShowAttachments(!showAttachments)
                                      }
                                      style={{
                                        color: "#17a2b8",
                                        fontWeight: 500,
                                        textDecoration: "none",
                                        marginLeft: "10px",
                                      }}
                                    >
                                      {showAttachments
                                        ? "Hide Attachments"
                                        : `View Attachments (${attachments.length})`}
                                    </Button>
                                  )}
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </Table>
                      </Card>
                    </div>
                  )}

                  {/* Attachments Section */}
                  {showAttachments && attachments.length > 0 && (
                    <div className="px-3 mt-3">
                      <Card
                        style={{
                          border: "1px solid #e9ecef",
                          borderRadius: "8px",
                          overflow: "hidden",
                        }}
                      >
                        <div
                          style={{
                            backgroundColor: "#e3f2fd",
                            padding: "15px 20px",
                            borderBottom: "2px solid #2196f3",
                            borderLeft: "4px solid #2196f3",
                          }}
                        >
                          <MDTypography
                            variant="h6"
                            style={{ fontWeight: "bold", color: "#1976d2" }}
                          >
                            Attachments ({attachments.length})
                          </MDTypography>
                        </div>
                        <div style={{ padding: "20px" }}>
                          <Row>
                            {attachments.map((file, idx) => (
                              <Col md={6} key={idx} className="mb-3">
                                <div
                                  style={{
                                    padding: "15px",
                                    border: "1px solid #dee2e6",
                                    borderRadius: "6px",
                                    backgroundColor: "#f8f9fa",
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                  }}
                                >
                                  <div>
                                    <MDTypography
                                      variant="body2"
                                      style={{
                                        fontWeight: 500,
                                        marginBottom: "5px",
                                      }}
                                    >
                                      Attachment {idx + 1}
                                    </MDTypography>
                                    <MDTypography
                                      variant="caption"
                                      style={{ color: "#6c757d", wordBreak: "break-all" }}
                                    >
                                      {fileNameFromUrl(file.image_url)}
                                    </MDTypography>
                                  </div>
                                  <Button
                                    color="info"
                                    size="sm"
                                    onClick={() => {
                                      setViewingAttachment(file);
                                      setAttachmentModal(true);
                                    }}
                                    style={{
                                      fontWeight: 500,
                                      whiteSpace: "nowrap",
                                    }}
                                  >
                                    View
                                  </Button>
                                </div>
                              </Col>
                            ))}
                          </Row>
                        </div>
                      </Card>
                    </div>
                  )}

                  {/* Attachment Viewer Modal */}
                  <Modal
                    isOpen={attachmentModal}
                    toggle={toggleAttachmentModal}
                    size="xl"
                    style={{ maxWidth: "90vw" }}
                  >
                    <ModalHeader toggle={toggleAttachmentModal}>
                      View Attachment
                      {viewingAttachment && (
                        <span
                          style={{
                            fontSize: "14px",
                            color: "#6c757d",
                            marginLeft: "10px",
                          }}
                        >
                          {fileNameFromUrl(viewingAttachment.image_url)}
                        </span>
                      )}
                    </ModalHeader>
                    <ModalBody style={{ padding: 0, minHeight: "70vh" }}>
                      {viewingAttachment && (
                        <div
                          style={{
                            width: "100%",
                            height: "70vh",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            backgroundColor: "#f5f5f5",
                            position: "relative",
                          }}
                          onContextMenu={(e) => e.preventDefault()}
                        >
                          {viewingAttachment.image_url
                            .toLowerCase()
                            .endsWith(".pdf") ? (
                            <iframe
                              src={`${resolveFileUrl(
                                viewingAttachment.image_url,
                              )}#toolbar=0&navpanes=0&scrollbar=0`}
                              style={{
                                width: "100%",
                                height: "100%",
                                border: "none",
                              }}
                              title="PDF Viewer"
                            />
                          ) : (
                            <img
                              src={resolveFileUrl(viewingAttachment.image_url)}
                              alt="Attachment"
                              style={{
                                maxWidth: "100%",
                                maxHeight: "100%",
                                objectFit: "contain",
                                userSelect: "none",
                                pointerEvents: "none",
                              }}
                              onContextMenu={(e) => e.preventDefault()}
                              draggable={false}
                            />
                          )}
                        </div>
                      )}
                    </ModalBody>
                    <ModalFooter>
                      <Button color="secondary" onClick={toggleAttachmentModal}>
                        Close
                      </Button>
                    </ModalFooter>
                  </Modal>

                  <Modal isOpen={openRemark} toggle={handleRemark} size="lg">
                    <RemarksList remarks={remarks} />
                  </Modal>
                  {/* {JSON.stringify(data)} */}
                  {/* Content Section */}
                  <div className="px-3">
                    {isLoading ? (
                      <div style={{ textAlign: "center", padding: "40px" }}>
                        <Spinner color="success" />
                      </div>
                    ) : display && types !== "Budget Approval Released" ? (
                      // Show detailed table
                      <Card
                        style={{
                          border: "1px solid #e9ecef",
                          borderRadius: "8px",
                          overflow: "hidden",
                        }}
                      >
                        <div
                          style={{
                            backgroundColor: "#f8f9fa",
                            padding: "15px 20px",
                            borderBottom: "2px solid #dee2e6",
                            fontWeight: 600,
                            fontSize: "16px",
                          }}
                        >
                          Release Details
                        </div>
                        <Table
                          responsive
                          hover
                          className="mb-0"
                          style={{ fontSize: "14px" }}
                        >
                          <thead style={{ backgroundColor: "#f1f3f5" }}>
                            <tr>
                              <th style={{ padding: "12px", fontWeight: 600 }}>
                                Action
                              </th>
                              <th style={{ padding: "12px", fontWeight: 600 }}>
                                MDA
                              </th>
                              <th style={{ padding: "12px", fontWeight: 600 }}>
                                MDA Code
                              </th>
                              <th style={{ padding: "12px", fontWeight: 600 }}>
                                Economic Code
                              </th>
                              <th style={{ padding: "12px", fontWeight: 600 }}>
                                Activities
                              </th>
                              <th style={{ padding: "12px", fontWeight: 600 }}>
                                Program
                              </th>
                              <th
                                style={{
                                  padding: "12px",
                                  fontWeight: 600,
                                  textAlign: "right",
                                }}
                              >
                                Amount (₦)
                              </th>
                            </tr>
                          </thead>

                          <tbody>
                            {data?.map((item, idx) => (
                              <tr key={idx} style={getRowStyle(item)}>
                                {/* {JSON.stringify(data.length)} */}
                                <td
                                  style={{
                                    padding: "12px",
                                    textAlign: "center",
                                  }}
                                >
                                  <Button
                                    onClick={() => onEditClick(item)}
                                    size="sm"
                                    color="success"
                                    disabled={
                                      item.approval_status ===
                                        "Approval Initiated" ||
                                      item.approval_status ===
                                        "approvals Reviewed" ||
                                      item.approval_status ===
                                        "Approval Released" ||
                                      item.approval_status ===
                                        "Final Internal Controls" ||
                                      item.approval_status?.includes(
                                        " Returned",
                                      )
                                        ? false
                                        : true
                                    }
                                    style={{ fontWeight: 500 }}
                                  >
                                    Edit
                                  </Button>
                                  {data.length > 1 ? (
                                    <Button
                                      onClick={() => handleDeleteApi(item)}
                                      size="sm"
                                      color="danger"
                                      style={{ fontWeight: 500 }}
                                    >
                                      Del
                                    </Button>
                                  ) : null}
                                </td>
                                <td style={{ padding: "12px" }}>
                                  {item.mda_name}
                                </td>
                                <td style={{ padding: "12px" }}>
                                  {item.mda_code}
                                </td>
                                <td style={{ padding: "12px" }}>
                                  {item.economic_code}
                                </td>
                                <td style={{ padding: "12px" }}>
                                  {item.description_code}
                                </td>
                                <td style={{ padding: "12px" }}>
                                  {item.program_code}
                                </td>
                                <td
                                  style={{
                                    padding: "12px",
                                    textAlign: "right",
                                    fontWeight: 600,
                                  }}
                                >
                                  {formatNumber(item.amount)}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </Table>
                      </Card>
                    ) : !display ||
                      (types === "Approval Released" && !display) ? (
                      // Show PDF webview
                      <div
                        style={{
                          border: "1px solid #e9ecef",
                          borderRadius: "8px",
                          overflow: "hidden",
                          backgroundColor: "#fff",
                        }}
                      >
                        {data.length === 1 ? (
                          <RealiseCollectionPdfWebView
                            form={form}
                            selecOffer={formatNumber}
                            user={newUser}
                            today={moment().format("LL")}
                            title={title}
                          />
                        ) : (
                          <NewRelisePdfWebView
                            selectedData={pdfData}
                            selecOffer={formatNumber}
                            imageUrl={newUser && newUser.imageUrl}
                            today={moment().format("LL")}
                            user={newUser}
                            title={title}
                          />
                        )}
                      </div>
                    ) : null}
                  </div>
                </>
              )}
            </Grid>
          </Grid>
        </MDBox>
        <Modal isOpen={discard} toggle={discardToggle}>
          <p
            style={{
              color: "red",
              fontWeight: "500",
            }}
          >
            Are you sure?
          </p>
          <ModalBody>
            <Col md={12}>
              <Label>Add Remark</Label>
              <Input
                type="textarea"
                name="remark"
                value={form.remark}
                onChange={handleChanges}
                style={{
                  borderColor: discard ? "red" : "#54AC58",
                  borderWidth: 2,
                }}
              />
            </Col>
          </ModalBody>
          <ModalFooter className="d-flex justify-content-center">
            <Button
              color="warning"
              variant="warning"
              className="btn btn-warning"
              onClick={discardToggle}
            >
              Cancel
            </Button>

            <Button
              onClick={() => approveRequest("Discard")}
              disabled={loading}
              color="primary"
              variant="primary"
              className="btn btn-primary"
            >
              {loading ? "Loading..." : "Discard"}
            </Button>
          </ModalFooter>
        </Modal>

        <Modal isOpen={modal} toggle={toggle}>
          <ModalHeader>
            <span className="text-center" style={{ width: "100%" }}>
              <center>
                <p
                  style={{
                    color: "red",
                    fontWeight: "500",
                  }}
                >
                  Are you sure you want to return this release?
                </p>
              </center>
            </span>
          </ModalHeader>
          <ModalBody>
            <Col md={12}>
              <Label>
                Add Remark <span style={{ color: "red" }}>*</span> (Required)
              </Label>
              <Input
                type="textarea"
                name="remark"
                value={form.remark}
                onChange={handleChanges}
                placeholder="Please provide a reason for returning this release..."
                rows={4}
                style={{
                  borderColor: "red",
                  borderWidth: 2,
                }}
                required
              />
              {form.remark.trim() === "" && (
                <small
                  style={{ color: "red", marginTop: "5px", display: "block" }}
                >
                  Remark is required when returning a release
                </small>
              )}
            </Col>
          </ModalBody>
          <ModalFooter className="d-flex justify-content-center">
            <Button
              color="warning"
              variant="warning"
              className="btn btn-warning"
              onClick={toggle}
            >
              Cancel
            </Button>

            <Button
              variant="danger"
              className="btn btn-danger"
              onClick={() => {
                if (!form.remark || form.remark.trim() === "") {
                  addToast("Remark is required when returning a release", {
                    appearance: "error",
                    autoDismiss: true,
                    autoDismissTimeout: 5000,
                  });
                  return;
                }
                approveRequest(return_status);
                toggle();
              }}
              disabled={loading || !form.remark || form.remark.trim() === ""}
            >
              {loading ? "Processing..." : "Return"}
            </Button>
          </ModalFooter>
        </Modal>
        <Modal isOpen={modal1} toggle={toggle1}>
          <ModalHeader>
            <span className="text-center" style={{ width: "100%" }}>
              <center>
                <p
                  style={{
                    color: "#54AC58",
                    fontWeight: "500",
                  }}
                >
                  Are you sure?
                </p>
              </center>
            </span>
          </ModalHeader>
          <ModalBody>
            <Col md={12}>
              <Label>Add Remark</Label>
              <Input
                type="textarea"
                name="remark"
                value={form.remark}
                onChange={handleChanges}
                style={{
                  borderColor: "#54AC58",
                  borderWidth: 2,
                }}
              />
            </Col>
          </ModalBody>
          <ModalFooter className="d-flex justify-content-center">
            <Button
              color="warning"
              variant="warning"
              className="btn btn-warning"
              onClick={toggle1}
            >
              Cancel
            </Button>
            <Button
              onClick={() => approveRequest(approval_status)}
              disabled={loading}
              color="primary"
              variant="primary"
              className="btn btn-primary"
            >
              {loading ? "Loading..." : "Approve"}
            </Button>
          </ModalFooter>
        </Modal>

        <Modal isOpen={edit} toggle={toggleEdit} size="xl" scrollable>
          <ModalHeader toggle={toggleEdit} style={{ backgroundColor: "#f8f9fa" }}>
            <span style={{ fontWeight: 600 }}>
              Edit Release — {form.approval_no}
            </span>
          </ModalHeader>

          <ModalBody style={{ backgroundColor: "#fafafa", padding: "24px" }}>
            {/* ── Section: Release Information ─────────────────────────── */}
            <div style={{ backgroundColor: "#f8f9fa", padding: "12px 16px", borderRadius: 8, borderLeft: "4px solid #4caf50", marginBottom: 20 }}>
              <strong style={{ color: "#2c3e50" }}>Release Information</strong>
            </div>
{/* {JSON.stringify(_data)} */}
            <Row className="mb-3">
              <Col md={4}>
                <Label style={{ fontWeight: 600 }}>Release Type</Label>
                <Input
                  type="select"
                  value={editSteps}
                  onChange={({ target: { value } }) => setEditSteps(value)}
                >
                  <option value="1">Recurrent Project</option>
                  <option value="2">Capital Project</option>
                </Input>
              </Col>
              <Col md={4}>
                <Label style={{ fontWeight: 600 }}>Collection Date <span style={{ color: "red" }}>*</span></Label>
                <Input
                  type="date"
                  name="collection_date"
                  value={form.collection_date || ""}
                  onChange={({ target: { name, value } }) => handleHeaderChange(name, value)}
                />
              </Col>
              <Col md={4}>
                <Label style={{ fontWeight: 600 }}>Approval Date <span style={{ color: "red" }}>*</span></Label>
                <Input
                  type="date"
                  name="approval_date"
                  value={form.approval_date || ""}
                  onChange={({ target: { name, value } }) => handleHeaderChange(name, value)}
                />
              </Col>
              <Col md={4} className="mt-3">
                <Label style={{ fontWeight: 600 }}>Approved By <span style={{ color: "red" }}>*</span></Label>
                <Input
                  type="select"
                  name="approved_by"
                  value={form.approved_by || ""}
                  onChange={({ target: { name, value } }) => handleHeaderChange(name, value)}
                >
                  <option value="">--Select--</option>
                  <option value="HE">HE</option>
                  <option value="Exco">Exco</option>
                  <option value="Others">Others</option>
                </Input>
              </Col>
              <Col md={4} className="mt-3">
                <Label style={{ fontWeight: 600 }}>Reference No <span style={{ color: "red" }}>*</span></Label>
                <Input
                  name="approval_no"
                  value={form.approval_no || ""}
                  onChange={({ target: { name, value } }) => handleHeaderChange(name, value)}
                />
              </Col>
            </Row>

            {/* ── Section: MDA & Budget ────────────────────────────────── */}
            <div style={{ backgroundColor: "#f8f9fa", padding: "12px 16px", borderRadius: 8, borderLeft: "4px solid #4caf50", marginBottom: 20, marginTop: 8 }}>
              <strong style={{ color: "#2c3e50" }}>MDA &amp; Budget Information</strong>
            </div>

            <Row className="mb-3">
              <Col md={4}>
                <Label style={{ fontWeight: 600 }}>Select MDA to be charged <span style={{ color: "red" }}>*</span></Label>
                <Typeahead
                  id="edit-mda"
                  ref={mdaRef}
                  size="sm"
                  options={distinctAdmins}
                  labelKey={(opt) => opt.admin_description}
                  selected={distinctAdmins.filter((a) => a.admin_code === form.mda_code)}
                  onChange={handleEditMdaCode}
                  placeholder={fetching ? "Loading…" : "Select MDA"}
                  isLoading={fetching}
                />
                {form.mda_name && (
                  <small style={{ color: "#666", marginTop: 4, display: "block", fontSize: 10 }}>
                    <strong>CC: </strong>{form.copies?.officeTitle || "cc not set"}
                  </small>
                )}
              </Col>
              <Col md={4}>
                <Label style={{ fontWeight: 600 }}>Administrative Code</Label>
                <Input value={form.mda_code || ""} disabled style={{ backgroundColor: "#e9ecef" }} />
              </Col>
              <Col md={4}>
                <Label style={{ fontWeight: 600 }}>Select MDA Payable to (if any)</Label>
                <Typeahead
                  id="edit-mda-head"
                  size="sm"
                  options={allMdaAdmins}
                  labelKey={(opt) => `${opt.admin_description}/${opt.admin_code}`}
                  selected={allMdaAdmins.filter((a) => a.admin_code === form.mda_head_code)}
                  onChange={handleEditMdaCode1}
                  placeholder="Select Head"
                />
                {form.mda_head && (
                  <small style={{ color: "#666", marginTop: 4, display: "block" }}>
                    <strong>CC: </strong>{form.copies1?.officeTitle || "cc not set"}
                  </small>
                )}
              </Col>

              <Col md={4} className="mt-3">
                <Label style={{ fontWeight: 600 }}>Select Economic Code <span style={{ color: "red" }}>*</span></Label>
                <Typeahead
                  id="edit-economic"
                  ref={economicRef}
                  size="sm"
                  options={getDistinctObjects(
                    filteredEconomicCode.filter(
                      (item) => item.economic_code && item.economic_description &&
                        item.economic_code.trim() !== "" && item.economic_description.trim() !== "",
                    ),
                    "economic_code",
                    "economic_description",
                  )}
                  labelKey={(opt) => `${opt.economic_description} - ${opt.economic_code}`}
                  selected={getDistinctObjects(
                    filteredEconomicCode.filter((item) => item.economic_code === (form.mda_economic_code || form.economic_code)),
                    "economic_code",
                    "economic_description",
                  ).slice(0, 1)}
                  onChange={handleEditEconomicCode}
                  placeholder="Select Economic Code"
                />
              </Col>
              <Col md={4} className="mt-3">
                <Label style={{ fontWeight: 600 }}>Description</Label>
                <Input
                  value={form.mda_description || form.description_code || ""}
                  disabled
                  style={{ backgroundColor: "#e9ecef" }}
                />
              </Col>
              <Col md={4} className="mt-3">
                <Label style={{ fontWeight: 600 }}>Copy to (CC MDA, if any)</Label>
                <Typeahead
                  id="edit-cc-mda"
                  ref={ccMdaRef}
                  size="sm"
                  options={allMdaAdmins.length ? allMdaAdmins : distinctAdmins}
                  labelKey={(opt) => opt.admin_description}
                  selected={(allMdaAdmins.length ? allMdaAdmins : distinctAdmins).filter(
                    (a) => a.admin_description === (form.cc_mda_name || form.cc),
                  )}
                  onChange={(selected) => {
                    if (selected?.length) {
                      handleHeaderChange("cc", selected[0].admin_description);
                      handleHeaderChange("cc_mda_name", selected[0].admin_description);
                    } else {
                      handleHeaderChange("cc", "");
                      handleHeaderChange("cc_mda_name", "");
                    }
                  }}
                  placeholder="Select MDA for CC"
                />
              </Col>
            </Row>

            {/* ── Capital Project Codes (only when type = Capital) ─────── */}
            {editSteps === "2" && (
              <>
                <div style={{ backgroundColor: "#e3f2fd", padding: "12px 16px", borderRadius: 8, borderLeft: "4px solid #2196f3", marginBottom: 20, marginTop: 8 }}>
                  <strong style={{ color: "#1565c0" }}>Capital Project Codes</strong>
                </div>
                <Row className="mb-3">
                  <Col md={3}>
                    <Label style={{ fontWeight: 600 }}>Fund Code</Label>
                    <Typeahead
                      id="edit-fund"
                      ref={fundRef}
                      size="sm"
                      options={getDistinctObjects(
                        filteredEconomicCode.filter((item) => item.fund_code && item.fund_code.trim() !== ""),
                        "fund_code", "fund_description",
                      )}
                      labelKey={(opt) => `${opt.fund_code}/${opt.fund_description}`}
                      selected={getDistinctObjects(
                        filteredEconomicCode.filter((item) => item.fund_code === form.fund_code),
                        "fund_code", "fund_description",
                      ).slice(0, 1)}
                      onChange={(selected) => {
                        if (selected?.length) handleHeaderChange("fund_code", selected[0].fund_code);
                        else handleHeaderChange("fund_code", "");
                      }}
                      placeholder="Select Fund Code"
                    />
                  </Col>
                  <Col md={3}>
                    <Label style={{ fontWeight: 600 }}>Functional Code</Label>
                    <Typeahead
                      id="edit-functional"
                      ref={functionalRef}
                      size="sm"
                      options={getDistinctObjects(
                        filteredEconomicCode.filter((item) => item.functional_code && item.functional_code.trim() !== ""),
                        "functional_code", "functional_description",
                      )}
                      labelKey={(opt) => `${opt.functional_code}/${opt.functional_description}`}
                      selected={getDistinctObjects(
                        filteredEconomicCode.filter((item) => item.functional_code === form.functional_code),
                        "functional_code", "functional_description",
                      ).slice(0, 1)}
                      onChange={(selected) => {
                        if (selected?.length) handleHeaderChange("functional_code", selected[0].functional_code);
                        else handleHeaderChange("functional_code", "");
                      }}
                      placeholder="Select Functional Code"
                    />
                  </Col>
                  <Col md={3}>
                    <Label style={{ fontWeight: 600 }}>Program Code</Label>
                    <Typeahead
                      id="edit-program"
                      ref={programRef}
                      size="sm"
                      options={getDistinctObjects(
                        filteredEconomicCode.filter((item) => item.program_code && item.program_code.trim() !== ""),
                        "program_code", "program_description",
                      )}
                      labelKey={(opt) => `${opt.program_code}/${opt.program_description}`}
                      selected={getDistinctObjects(
                        filteredEconomicCode.filter((item) => item.program_code === form.program_code),
                        "program_code", "program_description",
                      ).slice(0, 1)}
                      onChange={(selected) => {
                        if (selected?.length) handleHeaderChange("program_code", selected[0].program_code);
                        else handleHeaderChange("program_code", "");
                      }}
                      placeholder="Select Program Code"
                    />
                  </Col>
                  <Col md={3}>
                    <Label style={{ fontWeight: 600 }}>Geo Code</Label>
                    <Typeahead
                      id="edit-geo"
                      ref={geoRef}
                      size="sm"
                      options={getDistinctObjects(
                        filteredEconomicCode.filter((item) => item.geo_code && item.geo_code.trim() !== ""),
                        "geo_code", "geo_description",
                      )}
                      labelKey={(opt) => `${opt.geo_code}/${opt.geo_description}`}
                      selected={getDistinctObjects(
                        filteredEconomicCode.filter((item) => item.geo_code === form.geo_code),
                        "geo_code", "geo_description",
                      ).slice(0, 1)}
                      onChange={(selected) => {
                        if (selected?.length) handleHeaderChange("geo_code", selected[0].geo_code);
                        else handleHeaderChange("geo_code", "");
                      }}
                      placeholder="Select Geo Code"
                    />
                  </Col>
                </Row>
              </>
            )}

            {/* ── Section: Budget & Amount ─────────────────────────────── */}
            <div style={{ backgroundColor: "#fff3e0", padding: "12px 16px", borderRadius: 8, borderLeft: "4px solid #ff9800", marginBottom: 20, marginTop: 8 }}>
              <strong style={{ color: "#e65100" }}>Budget &amp; Amount Details</strong>
            </div>

            <Row className="mb-3">
              <Col md={4}>
                <Label style={{ fontWeight: 600 }}>Budget Balance</Label>
                <div style={{ position: "relative" }}>
                  <Input
                    value={
                      isNaN(form.mda_budget_balance)
                        ? form.mda_budget_balance
                        : formatNumber(form.mda_budget_balance) || ""
                    }
                    disabled
                    style={{ backgroundColor: "#e9ecef", fontWeight: 600, color: form.mda_budget_balance === "Budget Exhausted" ? "#d32f2f" : "#2c3e50" }}
                  />
                  {balLoanding && (
                    <Spinner size="sm" color="success" style={{ position: "absolute", right: 10, top: "50%", transform: "translateY(-50%)" }} />
                  )}
                </div>
              </Col>
              <Col md={4}>
                <Label style={{ fontWeight: 600 }}>
                  Approved Amount <span style={{ color: "red" }}>*</span>
                  <span style={{ color: "#4caf50", fontSize: 13, marginLeft: 8 }}>
                    ({formatNumber(form.approved_amount)})
                  </span>
                </Label>
                <Input
                  type="number"
                  name="approved_amount"
                  value={form.approved_amount || ""}
                  onChange={({ target: { name, value } }) => handleHeaderChange(name, value)}
                  style={{ border: "2px solid #4caf50", fontWeight: 600 }}
                />
              </Col>
              <Col md={4}>
                <Label style={{ fontWeight: 600 }}>Add Remark</Label>
                <Input
                  type="text"
                  name="add_remark"
                  value={form.add_remark || ""}
                  onChange={({ target: { name, value } }) => handleHeaderChange(name, value)}
                />
              </Col>
            </Row>

            {/* ── Narration ────────────────────────────────────────────── */}
            <Row className="mb-4">
              <Col md={12}>
                <Label style={{ fontWeight: 600 }}>Narration <span style={{ color: "red" }}>*</span></Label>
                <Input
                  type="textarea"
                  name="narration"
                  rows={4}
                  value={form.narration || ""}
                  onChange={({ target: { name, value } }) => handleHeaderChange(name, value)}
                  style={{ border: "1px solid #ced4da", borderRadius: 6 }}
                />
              </Col>
            </Row>

            {/* ── Per-row amount/narration editors ─────────────────────── */}
            {data.length > 1 && (
              <>
                <div style={{ backgroundColor: "#f8f9fa", padding: "12px 16px", borderRadius: 8, borderLeft: "4px solid #6c757d", marginBottom: 16 }}>
                  <strong style={{ color: "#495057" }}>Row-level Details</strong>
                </div>
                {data.map((item, idx) => (
                  <div
                    key={idx}
                    style={{ border: "1px solid #dee2e6", borderRadius: 6, padding: 12, marginBottom: 12 }}
                  >
                    <div style={{ marginBottom: 8 }}>
                      <small style={{ fontWeight: 600, color: "#495057" }}>
                        Row {idx + 1} — Narration
                      </small>
                      <Input
                        type="textarea"
                        value={item.narration || ""}
                        rows={2}
                        onChange={({ target: { value } }) => handleDataChange("narration", value, idx)}
                        style={{ marginTop: 4, borderRadius: 6, border: "1px solid #ced4da", padding: 8 }}
                      />
                    </div>
                    <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 8 }}>
                      <div>
                        <small style={{ fontWeight: 600, color: "#495057" }}>Amount</small>
                        <Input
                          size="sm"
                          value={item.amount || ""}
                          onChange={({ target: { value } }) => handleDataChange("amount", value, idx)}
                        />
                      </div>
                      <div>
                        <small style={{ fontWeight: 600, color: "#495057" }}>MDA</small>
                        <Input
                          size="sm"
                          value={item.mda_name || ""}
                          onChange={({ target: { value } }) => handleDataChange("mda_name", value, idx)}
                        />
                      </div>
                      <div>
                        <small style={{ fontWeight: 600, color: "#495057" }}>MDA Code</small>
                        <Input
                          size="sm"
                          value={item.mda_code || ""}
                          onChange={({ target: { value } }) => handleDataChange("mda_code", value, idx)}
                        />
                      </div>
                      <div>
                        <small style={{ fontWeight: 600, color: "#495057" }}>Activities</small>
                        <Input
                          size="sm"
                          value={item.description_code || ""}
                          onChange={({ target: { value } }) => handleDataChange("description_code", value, idx)}
                        />
                      </div>
                      <div>
                        <small style={{ fontWeight: 600, color: "#495057" }}>Economic Code</small>
                        <Input
                          size="sm"
                          value={item.economic_code || ""}
                          onChange={({ target: { value } }) => handleDataChange("economic_code", value, idx)}
                        />
                      </div>
                      <div>
                        <small style={{ fontWeight: 600, color: "#495057" }}>Program</small>
                        <Input
                          size="sm"
                          value={item.program_code || ""}
                          onChange={({ target: { value } }) => handleDataChange("program_code", value, idx)}
                        />
                      </div>
                    </div>
                  </div>
                ))}
              </>
            )}
          </ModalBody>

          <ModalFooter style={{ backgroundColor: "#f8f9fa" }} className="d-flex justify-content-center">
            <Button color="warning" onClick={toggleEdit}>Cancel</Button>
            <Button color="success" onClick={submitReview} disabled={submittingReview}>
              {submittingReview ? <><Spinner size="sm" /> Saving…</> : "Save Changes"}
            </Button>
          </ModalFooter>
        </Modal>
      </DashboardLayout>
    </div>
  );
}
